import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Events", id: "events" },
  { label: "Schedule", id: "schedule" },
  { label: "Guidelines", id: "guidelines" },
  { label: "Team", id: "team" },
  { label: "Register", id: "register" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur border-b border-[#B8873B]/30" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12 flex items-center justify-between h-16">
        <a
          href="#home"
          onClick={go("home")}
          data-testid="nav-logo"
          className="font-display tracking-[0.4em] text-base uppercase text-marble"
        >
          Tradella
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-[11px] tracking-[0.3em] uppercase text-white/65 hover:text-[#B8873B] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#register"
          onClick={go("register")}
          data-testid="nav-register-btn"
          className="hidden lg:inline-flex items-center px-5 py-2.5 bg-[#B8873B] text-black uppercase text-[11px] tracking-[0.3em] hover:bg-[#E6C88A] transition-colors"
        >
          Register
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#B8873B] p-2"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-[max-height] duration-300 border-t border-[#B8873B]/20 ${
          open ? "max-h-[480px]" : "max-h-0"
        } bg-black/95`}
      >
        <nav className="flex flex-col px-6 py-4 gap-1">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={go(l.id)}
              data-testid={`nav-mobile-link-${l.id}`}
              className="text-sm tracking-[0.25em] uppercase text-white/75 hover:text-[#B8873B] py-2.5 border-b border-white/5"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
